import axios from 'axios';
import { eventHelper } from '@/utils/helpers';

class Auth {
  constructor() {
    const token = window.localStorage.getItem('token');
    const user = window.localStorage.getItem('user');

    this.token = token;
    this.user = user ? JSON.parse(user) : null;
    if (this.token) {
      Auth.updateAxiosToken(this.token);
    }
  }

  static updateAxiosToken(token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  setToken(token) {
    window.localStorage.setItem('token', token);
    this.token = token;
    Auth.updateAxiosToken(this.token);
  }

  setUser(user) {
    window.localStorage.setItem('user', JSON.stringify(user));
    this.user = user;
  }

  logout() {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('user');
    this.token = null;
    this.user = null;
    Auth.updateAxiosToken(null);
    eventHelper.$emit('userLoggedOut', true);
  }

  check() {
    return !!this.token;
  }

  loginPopup() {
    return this.userAgentApplication.loginPopup(this.CONFIG.graphScopes);
  }

  acquireTokenSilent() {
    return this.userAgentApplication.acquireTokenSilent(this.CONFIG.graphScopes);
  }

  acquireTokenPopup() {
    return this.userAgentApplication.acquireTokenPopup(this.CONFIG.graphScopes);
  }
}

export default Auth;
